<script setup>
import { getI18n } from '@/plugins/i18n'
import { useWebSiteStore } from '@/stores/web-site.store'

const i18n = getI18n()
const webSiteStore = useWebSiteStore()
</script>

<template>
  <div class="row items-center no-wrap q-gutter-x-md">
    <q-toggle v-model="webSiteStore.roiComparisonShowMine" :label="i18n.t('roiCompare.showMine')" />
    <q-toggle v-model="webSiteStore.roiComparisonShowShared" :label="i18n.t('roiCompare.showShared')" />
  </div>
</template>
